export const LOADER_UPDATE = 'LOADER_UPDATE' as const;